import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { User } from '@/types'

interface AuthState {
  user: User | null
  isAuthenticated: boolean
  isAdmin: boolean
  isSalesManager: boolean
  isLoading: boolean
  authEnabled: boolean
  error: string | null

  // Actions
  setUser: (user: User | null) => void
  setLoading: (loading: boolean) => void
  setAuthEnabled: (enabled: boolean) => void
  setError: (error: string | null) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      isAdmin: false,
      isSalesManager: false,
      isLoading: true,
      authEnabled: true,
      error: null,

      setUser: (user) =>
        set({
          user,
          isAuthenticated: !!user,
          isAdmin: user?.role === 'admin' || user?.is_admin === true,
          isSalesManager: user?.role === 'sales_manager',
          error: null,
        }),

      setLoading: (isLoading) => set({ isLoading }),

      setAuthEnabled: (authEnabled) => set({ authEnabled }),

      setError: (error) => set({ error }),

      logout: () =>
        set({
          user: null,
          isAuthenticated: false,
          isAdmin: false,
          isSalesManager: false,
          error: null,
        }),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        // Only persist minimal auth state
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
)
